<template>
  <section id="layout-left-side">
    <ul>
      <li>
        <router-link to="textbooks">教科書 管理</router-link>
      </li>
      <li>
        <router-link to="subjects">教科マスタ</router-link>
      </li>
      <li>
        <router-link to="companies">企業マスタ</router-link>
      </li>

    </ul>
  </section>
</template>

<script>
export default {
  name: 'LayoutLeftSide',
  props: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#layout-left-side {
  min-width: 200px;
  max-width: 300px;
  border: solid 1px #2b2f3a;
}

a {
  text-decoration: none;
}

</style>
